import { Alert, Box, Button, Snackbar } from '@mui/material';
import { useRef, ChangeEvent, useState } from 'react';
import { useGetImages, useUploadImage } from '../../api/styleBoard';
import { useGetSignedUserOrUserFromState } from '../../hooks/auth';

export const UploadButton = () => {
  const uploadMutation = useUploadImage();
  const user = useGetSignedUserOrUserFromState();

  const { data } = useGetImages(user?.userId || '');

  const fileInput = useRef<HTMLInputElement>(null);
  const handleUploadClick = () => {
    if (fileInput.current) {
      fileInput.current.click();
    }
  };

  const [showError, setShowError] = useState(false);
  const [errorMessage, setShowErrorMessage] = useState(
    'Something went wrong. Please try again.'
  );

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const formData = new FormData();
    const file = event.target.files?.[0];

    if (file && user?.userId) {
      if (file.size > 40 * 1024 * 1024) {
        setShowError(true);
        setShowErrorMessage(
          'File size exceeds 40MB. Please choose a smaller file.'
        );
        return;
      }
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
        setShowError(true);
        setShowErrorMessage(
          'Invalid file type. Please upload a JPEG, PNG, or WebP file.'
        );
        return;
      }
      if (data.length >= 25) {
        setShowError(true);
        setShowErrorMessage(
          'You have reached the maximum number of images allowed.'
        );
        return;
      }
      formData.append('file', file);
      formData.append('upload_preset', 'cjkgrd51');
      formData.append('tags', `${user?.userId}-style-board`);
      formData.append(
        'metadata',
        `customer_id=${user?.userId}|priority_rank=${(data?.length || 0) + 1}`
      );
      uploadMutation.mutate(formData);
    }
  };
  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={showError}
        autoHideDuration={6000}
        onClose={() => setShowError(false)}
      >
        <Alert severity="error">{errorMessage}</Alert>
      </Snackbar>
      <Box>
        <input
          type="file"
          ref={fileInput}
          style={{ display: 'none' }}
          accept="image/jpeg,image/png,image/webp"
          onChange={handleFileChange}
        />
        <Button
          disabled={uploadMutation.isPending}
          className="upload"
          onClick={handleUploadClick}
        >
          {uploadMutation.isPending ? 'Uploading' : 'Upload'}
        </Button>
      </Box>
    </>
  );
};
